import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import {
  FacebookIcon,
  FacebookShareButton,
  HatenaIcon,
  HatenaShareButton,
  XIcon,
  TwitterShareButton,
} from "react-share"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Card from "../components/card"
import Container from "../components/container"
import SectionTitle from "../components/sectionTitle"
import Sidebar from "../components/sidebar"
import TagLink from "../components/tagLink"
import CdpFooter from "../components/cdp-footer"

import "./blog-post.css"

const BlogPostTemplate = ({ pageContext, data, location }) => {
  const [isTocExpanded, toggleTocExpansion] = useState(false)
  const post = data.markdownRemark
  const { solution, trend } = data
  const tags = data.allTagsJson.nodes

  const mainImage = post.frontmatter.cover
    ? getImage(post.frontmatter.cover)
    : null

  //let isTocExpanded = false

  function onTocClick() {
    toggleTocExpansion(!isTocExpanded)
  }

  useEffect(() => {
    const Toc = document.querySelector(".table-of-contents")
    if (!Toc) return
    const TocList = document.querySelector(".table-of-contents ul")
    let tocHeader
    if (!document.querySelector(".toc-header")) {
      tocHeader = document.createElement("button")
      const headerText = document.createTextNode("目次")
      tocHeader.classList.add("toc-header")
      tocHeader.appendChild(headerText)
      Toc.insertBefore(tocHeader, TocList)
    } else {
      tocHeader = document.querySelector(".toc-header")
    }
    tocHeader.addEventListener("click", onTocClick)
    return () => tocHeader.removeEventListener("click", onTocClick)
  })

  useEffect(() => {
    // ブラウザ環境でのみ実行することを確認
    if (typeof window !== "undefined") {
      // 除外したいドメインのリスト
      const excludedDomains = ["www.ever-rise.co.jp"];
      document.querySelectorAll('.blog-content a[target="_blank"]').forEach(link => {
        const linkHost = new URL(link.href).hostname; // リンクのホスト名を取得

        // リンクが画像を含まない、かつ除外リストに含まれていないドメインの場合にクラスを追加
        if (!link.querySelector('img') && !excludedDomains.includes(linkHost)) {
          link.classList.add('external-text-link');
        }
      });
    }
  }, [])
  
  return (
    <Layout location={location}>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={
          post.frontmatter.cover
            ? post.frontmatter.cover.childImageSharp.fixed.src
            : null
        }
      />
      <Container className="pt-7">
        <div className="lg:flex justify-between">
          <div className="lg:pr-9 lg:w-3/4 flex-1">
            <article
              className="bg-white lg:shadow-2xl lg:pr-24 lg:pl-24 lg:pt-14 lg:pb-14 blog-post"
              itemScope
              itemType="http://schema.org/Article"
            >
              <header className="mb-5 lg:mb-7">
                <div className="mb-4 lg:mb-5 flex justify-between">
                  <p className="text-textGray-80">{post.frontmatter.date}</p>
                  <div className="flex flex-gap-2">
                    <FacebookShareButton
                      url={`${data.site.siteMetadata.siteUrl}${post.fields.meta.slug}`}
                    >
                      <FacebookIcon size={32} round />
                    </FacebookShareButton>
                    <TwitterShareButton
                      title={post.frontmatter.title}
                      url={`${data.site.siteMetadata.siteUrl}${post.fields.meta.slug}`}
                    >
                      <XIcon size={32} round />
                    </TwitterShareButton>
                    <HatenaShareButton
                      url={`${data.site.siteMetadata.siteUrl}${post.fields.meta.slug}`}
                    >
                      <HatenaIcon size={32} round />
                    </HatenaShareButton>
                  </div>
                </div>
                <h1
                  itemProp="headline"
                  className="text-brandNavy font-bold lg:text-4xl text-2xl tracking-wider mb-5 lg:mb-7 leading-normal lg:leading-normal"
                >
                  {post.frontmatter.title}
                </h1>
                <div className="flex flex-wrap flex-gap-2 pb-6 lg:pb-9">
                  {tags.map(tag => (
                    <TagLink
                      name={tag.name}
                      title={tag.title}
                      key={`tag-list-${tag.name}`}
                      size={"s"}
                    />
                  ))}
                </div>

                {mainImage ? (
                  <GatsbyImage
                    image={mainImage}
                    alt={post.frontmatter.title}
                    className="max-w-full"
                  />
                ) : null}
              </header>
              <section
                dangerouslySetInnerHTML={{ __html: post.html }}
                itemProp="articleBody"
                className={`text-textGray-100 blog-content text-sm lg:text-base ${
                  isTocExpanded ? `toc-expanded` : ``
                }`}
              />
              <footer>
                {post.frontmatter.solution === "integral-core" ? (
                  <div className="">
                    <div class="blog-content lg:text-base mt-8 text-textGray-100">
                      <h2>CDP「INTEGRAL-CORE」で実現できるノーコードでのデータ分析・施策実施</h2>
                      <p>弊社EVERRISEでは、あらゆる顧客接点のデータを1つに統合し、顧客を深く理解したうえで、自由自在なコミュニケーションを実現するCDP「<a href="https://www.ever-rise.co.jp/integral-core/" class="font-bold">INTEGRAL-CORE</a>」を提供しています。これまでTVerさまやキーコーヒーさま、hoyuさまなどを含め複数社の導入実績がございます。</p>
                        <ul>
                          <li>CDP「INTEGRAL-CORE」の特長
                            <ul>
                              <li>顧客に関するあらゆるデータを収集・統合</li>
                              <li>ノーコードでデータ集計やセグメント作成</li>
                              <li>外部連携機能でBIツール・MA・CRMなどへデータを渡し、マーケティング施策へ活用可能</li>
                              <li>自社開発システムならではの総合支援体制</li>
                              <li>専用環境での提供も可能な国産CDP</li>
                            </ul>
                          </li>
                        </ul>
                      <p>「CDPを使うにはプログラミングの知識が必要で、操作が難しそう」と考えている方も多いと思います。しかし、CDP「INTEGRAL-CORE」は、顧客データの分析・施策の実行に向けて、ノーコードで対応できる機能を搭載しています。</p>
                      <p>CDP「INTEGRAL-CORE」が備えるノーコードの機能について、詳しくは下記の無料資料をご覧ください。ノーコードで実現可能な分析・施策の流れを、実際の画面を用いながら紹介しています。</p>
                      <p class="font-bold">無料資料：
                        <a href="https://www.ever-rise.co.jp/integral-core/resource/integral-core-nocord/">CDP「INTEGRAL-CORE」で始めるノーコードでのデータ活用</a>
                      </p>
                    </div>
                    <a
                      href="https://www.ever-rise.co.jp/integral-core/resource/integral-core-nocord/"
                      target="_blank"
                      className="hover:opacity-80 block"
                    >
                      <StaticImage
                        layout="fullWidth"
                        src={`../images/banner/integral-core-nocord_banner.png`}
                      />
                    </a>
                    <div class="blog-content lg:text-base mt-8 text-textGray-100">
                    <p>また、弊社はCDPの提供だけでなく、デジタルマーケティング領域における300件以上の開発実績で培ったノウハウを活かし、データ活用基盤構築のためのコンサルティングや自社の基幹システムを含めた各種システムと連携を行うための開発支援も行っています。</p>
                      <ul>
                        <li>自社にとってベストなシステムが分からない</li>
                        <li>どのように顧客データを管理していけばいいか迷っている</li>
                        <li>顧客データ活用やDXなど、どのように進めていけば良いか分からない</li>
                      </ul>
                      <p>上記のようなお悩みや、データ活用・CDPに関する疑問点がございましたらお気軽にお問合せください。</p>
                      <p>ブログやサイトに掲載しきれなかった事例のご紹介や、INTEGRAL-COREのデモリクエスト・お見積もりのご依頼も承っております！</p>
                      <div class="cta-button">
                        <p>
                          <a href="https://www.ever-rise.co.jp/integral-core/contact">導入相談・お問合せはこちら</a>
                        </p>
                      </div>
                    </div>
                  </div>
                ) : post.frontmatter.solution === "bridgesignal" ? (
                  <div className="">
                    <div class="blog-content lg:text-base mt-8 text-textGray-100">
                      <h2>弊社EVERRISEが提供するCDP「INTEGRAL-CORE」</h2>
                      <p>弊社EVERRISEでは、顧客データをノーコードで管理できるCDP「<a href="https://www.ever-rise.co.jp/integral-core/" class="font-bold">INTEGRAL-CORE</a>」を提供しており、これまでTVerさまやキーコーヒーさま、hoyuさまなどを含め複数社の導入実績がございます。</p>
                      <p>CDP「INTEGRAL-CORE」はBridgeSignalとも連携可能です。BridgeSignalとの連携により、GA4のデータに加え、そのほかのオンライン・オフラインデータも統合的に分析できるようになります。</p>
                        <ul>
                          <li>CDP「INTEGRAL-CORE」の特長
                            <ul>
                              <li>顧客に関するあらゆるデータを収集・統合</li>
                              <li>ノーコードでデータ集計やセグメント作成</li>
                              <li>外部連携機能でBIツール・MA・CRMなどへデータを渡し、マーケティング施策へ活用可能</li>
                              <li>自社開発システムならではの総合支援体制</li>
                              <li>専用環境での提供も可能な国産CDP</li>
                            </ul>
                          </li>
                        </ul>
                      <p>CDP「INTEGRAL-CORE」の機能や特長、ユースケース、実際の画面について、詳しくは下記の無料資料をご覧ください。</p>
                      <p class="font-bold">無料資料：
                        <a href="https://www.ever-rise.co.jp/integral-core/resource/integral-core/">CDP「INTEGRAL-CORE」ご紹介資料</a>
                      </p>
                    </div>
                    <a
                      href="https://www.ever-rise.co.jp/integral-core/resource/integral-core/"
                      target="_blank"
                      className="hover:opacity-80 block"
                    >
                      <StaticImage
                        layout="fullWidth"
                        src={`../images/integral-core_banner.png`}
                      />
                    </a>
                  </div>
                ) : post.frontmatter.solution === "jetjunction" ? (
                  <div className="">
                    <div class="blog-content lg:text-base mt-8 text-textGray-100">
                      <h2>弊社EVERRISEが提供するCDP「INTEGRAL-CORE」</h2>
                      <p>弊社EVERRISEでは、顧客データをノーコードで管理できるCDP「<a href="https://www.ever-rise.co.jp/integral-core/" class="font-bold">INTEGRAL-CORE</a>」を提供しており、これまでTVerさまやキーコーヒーさま、hoyuさまなどを含め複数社の導入実績がございます。</p>
                      <p>CDP「INTEGRAL-CORE」はJetJunctionと連携でき、JetJunctionの加工データなどの機能を使いながら、CDPとしてのデータ収集・統合・加工・連携の機能も扱えるため、より顧客データ活用がしやすいシステムとなっています。</p>
                        <ul>
                          <li>CDP「INTEGRAL-CORE」の特長
                            <ul>
                              <li>顧客に関するあらゆるデータを収集・統合</li>
                              <li>ノーコードでデータ集計やセグメント作成</li>
                              <li>外部連携機能でBIツール・MA・CRMなどへデータを渡し、マーケティング施策へ活用可能</li>
                              <li>自社開発システムならではの総合支援体制</li>
                              <li>専用環境での提供も可能な国産CDP</li>
                            </ul>
                          </li>
                        </ul>
                      <p>CDP「INTEGRAL-CORE」の機能や特長、ユースケース、実際の画面について、詳しくは下記の無料資料をご覧ください。</p>
                      <p class="font-bold">無料資料：
                        <a href="https://www.ever-rise.co.jp/integral-core/resource/integral-core/">CDP「INTEGRAL-CORE」ご紹介資料</a>
                      </p>
                    </div>
                    <a
                      href="https://www.ever-rise.co.jp/integral-core/resource/integral-core/"
                      target="_blank"
                      className="hover:opacity-80 block"
                    >
                      <StaticImage
                        layout="fullWidth"
                        src={`../images/integral-core_banner.png`}
                      />
                    </a>
                  </div>
                ) : post.frontmatter.solution === "admiral" ? (
                  <a
                    href="https://www.ever-rise.co.jp/admiral/"
                    target="_blank"
                    className="hover:opacity-80 block"
                  >
                    <StaticImage
                      layout="fullWidth"
                      src={`../images/admiral_banner.png`}
                    />
                  </a>
                ) : null}
              </footer>
            </article>
          </div>
          <div className="lg:w-1/4 lg:flex-shrink-0 blog-sidebar-height">
            <Sidebar
              banner={
                post.frontmatter.solution === "integral-core" ? [1] :
                post.frontmatter.solution === "admiral" ? [2] :
                post.frontmatter.solution === "system-integration" ? [3] : []
              }
            />
          </div>
        </div>
      </Container>
      <Container className="pt-7 lg:pt-12">
        <SectionTitle title="関連記事" bgText="Related Post" className="mb-6" />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-7">
          {pageContext.solution &&
            solution.nodes.map(post => (
              <Card post={post} size="m" key={`related-${post.id}`} />
            ))}
          {!pageContext.solution &&
            trend.nodes.map(post => (
              <Card post={post} size="m" key={`related-${post.id}`} />
            ))}
        </div>
      </Container>
      <Container className="pt-9 pb-14 lg:pb-20">
        <SectionTitle
          title="関連キーワード"
          bgText="Keywords"
          className="mb-6"
        />
        <div className="flex flex-wrap flex-gap-2 pb-6 lg:pb-9">
          {tags.map(tag => (
            <TagLink
              name={tag.name}
              title={tag.title}
              key={`tag-list-${tag.name}`}
              size={"l"}
            />
          ))}
        </div>
      </Container>
      {post.frontmatter.solution === "integral-core" && <CdpFooter />}
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($id: String!, $solution: String, $tags: [String]) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        meta {
          slug
        }
      }
      frontmatter {
        title
        date(formatString: "YYYY.MM.DD")
        description
        tags
        cover {
          childImageSharp {
            gatsbyImageData(width: 1280, formats: AUTO)
            fixed(width: 1200) {
              src
            }
          }
        }
        solution
      }
    }
    solution: allMarkdownRemark(
      limit: 6
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { solution: { eq: $solution } }
        id: { ne: $id }
        fields: { meta: { draft: { eq: false } } }
      }
    ) {
      nodes {
        fields {
          meta {
            slug
          }
        }
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          cover {
            childImageSharp {
              gatsbyImageData(width: 800, formats: AUTO)
            }
          }
          tags
        }
        id
      }
    }
    trend: allMarkdownRemark(
      limit: 6
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { tags: { in: "trend" } }
        id: { ne: $id }
        fields: { meta: { draft: { eq: false } } }
      }
    ) {
      nodes {
        fields {
          meta {
            slug
          }
        }
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          cover {
            childImageSharp {
              gatsbyImageData(width: 800, formats: AUTO)
            }
          }
        }
        id
      }
    }
    allTagsJson(
      filter: { name: { in: $tags } }
      sort: { fields: priority, order: DESC }
    ) {
      nodes {
        title
        name
      }
    }
  }
`
